export const apiPaths = {
  objective: '/objectives',
  users: '/users',
  quarters: '/quarters',
  quarter: '/quarter',
  userDetails: '/user-details',
  quarterlyUsers: '/quarterly-user-status',
  updateFeedback: '/quarterly-feedback',
  auditTrails: '/auditTrails',
  objectivesReport: '/objectives-report',
  quarterlyUserStatus: 'quarterly-user-status',
  annualReview: '/annual-review',
  annualReviewUserStatus: '/annual-reviews/user-status',
  cycles: '/review-cycles',
  competencies: '/competencies',
  myProfilePic: '/me/photos/48x48/$value',
  annualReviewAuditTrail: '/annualReviewAuditTrails',
  hrDashboardStats: '/annual-hr-review-stats',
  hrDashboardStatsFilter: '/average-competency-score-by-discipline',
  technologyCategories: '/technolgy-categories',
  technologiesByCategory: '/technical-skills-by-category',
  techSkill: '/technical-skill',
  userTechSkill: '/user-technical-skills',
  userSkills: '/user-skills',
  userInterests: '/user-interests',
  skillDomains: '/skill-domains',
  userSkillDomain: '/user-skill-domain',
  userSkillDomains: '/user-skill-domains',
  certificationCategories: '/certification-categories',
  certificationsByCategory: '/certifications-by-category',
  userCertification: '/user-certification',
  userCertifications: '/user-Certifications',
  menteeReviewStats: '/annual-mentee-review-stats',
  annualFeedbackReportHr: '/annual-feedback-Report',
};
